<template>
  <div class="w-full bg-white relative">
    <div v-if="isLoading" class="mt-64">
      <spinner/>
    </div>
    <div v-else
         class="w-full md:flex md:flex-wrap justify-center lg:justify-between md:rounded-lg">
      <div  class="w-full card mb-6" v-for="(season, index) in seasons" :key="index">
       <SeasonGameTypeCard :season="season"
                          @getSeasons="getSeasons"/>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/clients/partners';
import SeasonGameTypeCard from './SeasonGameTypeCard.vue';
import spinner from '@/views/partners/spiner';

export default {
  components: { SeasonGameTypeCard, spinner },
  data() {
    return {
      seasons: [],
      seasonToIncrease: null,
      isLoading: true,
    };
  },
  created() {
    this.getSeasons();
  },
  methods: {
    getSeasons() {
      client.get('/seasons')
        .then((response) => {
          this.seasons = response.data.data;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.card {
  border: 1px solid #DADADA;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  max-width:554px;
}
</style>
